import { useConnection, useWallet } from "@solana/wallet-adapter-react"
import { useState } from "react"
import * as anchor from '@coral-xyz/anchor'
import Idl from '../../idl/vesting.json'
import { PublicKey } from "@solana/web3.js"
import { VESTING_CONFIG_ACCOUNT, VESTING_PROGRAM_ID } from "utils/envs"

const PROGRAM_ID = new PublicKey(VESTING_PROGRAM_ID)

const TransferAdmin = () => {
    const { publicKey, signTransaction, signAllTransactions, sendTransaction, connected } = useWallet()
    const { connection } = useConnection()
    const [newAdmin, setNewAdmin] = useState('')
    const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!publicKey || !connected) return

        try {
            setLoading(true)

            // Create an anchor provider
            const provider = new anchor.AnchorProvider(
                connection,
                {
                publicKey,
                signTransaction: signTransaction!,
                signAllTransactions: signAllTransactions!
                },
                { commitment: 'confirmed' }
            )

            // Create the program instance with the provider
            const program = new anchor.Program(Idl as any, PROGRAM_ID, provider)

            const signature = await program.methods
                .transferAdmin()
                .accounts({
                    currentAdmin: publicKey,
                    newAdmin: new PublicKey(newAdmin),
                    config: new PublicKey(VESTING_CONFIG_ACCOUNT)
                })
                .rpc({commitment:"confirmed"})

            console.log(signature)
            console.log('>>> Transfer Admin successfully, new admin:', newAdmin)

            window.location.reload()
        } catch (error) {
            console.log('Failed transfer admin:', error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="bit-card w-full">
            <h2 className="bit-title mb-4">Transfer Admin</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                <label className="bit-label">Admin Address</label>
                <input
                    type="text"
                    value={newAdmin}
                    onChange={(e) => setNewAdmin(e.target.value)}
                    className="bit-input w-full"
                    placeholder="Enter new admin address"
                    disabled={loading}
                />
                </div>
                <div className="flex justify-end mt-8">
                    <button 
                        type="submit" 
                        className="bit-button"
                        disabled={loading}
                    >
                        {loading ? 'Loading...' : 'Transfer'}
                    </button>
                    </div>
            </form>
        </div>
    )
}

export default TransferAdmin